export default "__VITE_ASSET__Z3KMec$5__"